module.exports = __webpack_public_path__ + "img/avatar-01-140x140.b94f4859.png";